import { useEffect, useState } from 'react';
import { apiClient } from '../utils/apiClient';

export interface DossierRecommendation {
  id: string;
  title: string;
  domain: string;
  authorId: string | null;
  authorName: string | null;
  updatedAt: string | null;
}

export interface HalRecommendation {
  _id: string;
  titre: string;
  source: { nom?: string; url?: string };
  halMetadata?: {
    abstract?: string;
    keywords?: string[];
    authors?: string[];
    publication?: { type?: string; date?: string };
  };
}

interface RecommendationsResponse {
  dossiers: DossierRecommendation[];
  halResources: HalRecommendation[];
}

export const useRessourcesRecommendations = (limit: number = 5) => {
  const [dossiers, setDossiers] = useState<DossierRecommendation[]>([]);
  const [halResources, setHalResources] = useState<HalRecommendation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await apiClient(`/recommendations-ressources?limit=${limit}`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (cancelled) return;
        if (data.success) {
          const payload = data.data as RecommendationsResponse;
          setDossiers(payload.dossiers ?? []);
          setHalResources(payload.halResources ?? []);
        } else {
          setError('Erreur lors de la récupération des recommandations');
        }
      } catch (err) {
        if (!cancelled) {
          setError('Erreur lors de la récupération des recommandations');
          console.error('Erreur useRessourcesRecommendations:', err);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchRecommendations();
    return () => {
      cancelled = true;
    };
  }, [limit]);

  return { dossiers, halResources, loading, error };
};
